import { Link } from "react-router-dom";
import { Phone, MessageSquare, ArrowRight } from "lucide-react";
import { telLink, smsLink } from "@/data/site";

const base =
  "inline-flex items-center justify-center gap-2 rounded-md font-semibold tracking-tight transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:opacity-60";

const sizes = {
  md: "px-5 py-3 text-sm",
  lg: "px-7 py-4 text-base",
};

const variants = {
  primary: "bg-gold text-charcoal hover:bg-gold-dark shadow-sm hover:-translate-y-0.5 hover:shadow-md",
  forest: "bg-forest text-cream hover:bg-forest-light shadow-sm hover:-translate-y-0.5 hover:shadow-md",
  outline: "border border-forest/25 bg-transparent text-forest hover:bg-forest hover:text-cream hover:-translate-y-0.5",
  ghostLight: "border border-cream/30 bg-transparent text-cream hover:bg-cream/10 hover:-translate-y-0.5",
};

// Estimate CTA — links to the estimate section/form.
export const EstimateButton = ({ size = "md", variant = "primary", label = "Get a Free Estimate", to = "/contact#estimate", testid = "cta-estimate", className = "" }) => (
  <Link to={to} data-testid={testid} className={`${base} ${sizes[size]} ${variants[variant]} ${className}`}>
    {label}
    <ArrowRight className="h-4 w-4" strokeWidth={2.2} />
  </Link>
);

export const CallButton = ({ size = "md", variant = "forest", label = "Call Now", testid = "cta-call", className = "" }) => (
  <a href={telLink} data-testid={testid} className={`${base} ${sizes[size]} ${variants[variant]} ${className}`}>
    <Phone className="h-4 w-4" strokeWidth={2.2} />
    {label}
  </a>
);

export const TextButton = ({ size = "md", variant = "outline", label = "Text Us", testid = "cta-text", className = "" }) => (
  <a href={smsLink} data-testid={testid} className={`${base} ${sizes[size]} ${variants[variant]} ${className}`}>
    <MessageSquare className="h-4 w-4" strokeWidth={2.2} />
    {label}
  </a>
);
